import styled from 'styled-components'

type TPropsFlex = {
  $gap?: string
  $justifyContent?: string
  $alignItems?: string
  $paddingTop?: string
  $position?: string
  $marginBottom?: string
}

export const Column = styled.div<TPropsFlex>`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${({ $gap }) => $gap || '16px'};
  padding-top: ${({ $paddingTop }) => $paddingTop || 'none'};
  position: ${({ $position }) => $position || 'none'};
  align-items: ${({ $alignItems: alignItems }) => alignItems || 'center'};
`
export const Row = styled.div<TPropsFlex>`
  display: flex;
  width: 100%;
  gap: ${({ $gap }) => $gap || '16px'};
  justify-content: ${({ $justifyContent }) => $justifyContent || 'start'};
  align-items: ${({ $alignItems }) => $alignItems || 'center'};
  margin-bottom: ${({ $marginBottom }) => $marginBottom || 'none'};
`
